







import { Component, Vue } from 'vue-property-decorator';
import Headline from '@/components/help/sections/Headline.vue';
import Resources from '@/components/help/sections/Resources.vue';

@Component({
  components: {
    Headline,
    Resources
  }
})
export default class Help extends Vue {
}
